export const STAFF_ROLES = ["directeur", "admin", "comptable", "support"];
export const ROLE_LABELS = { directeur: "Directeur", admin: "Administrateur", comptable: "Comptable", support: "Service client", customer: "Client" };
export const isStaff = (user) => !!user && STAFF_ROLES.includes(user.role);

// Sections admin accessibles par rôle (le directeur voit tout)
export const SECTION_ACCESS = {
  dashboard: ["directeur", "admin", "comptable"],
  compta: ["directeur", "comptable"],
  general: ["directeur", "admin", "comptable"],
  catalogue: ["directeur", "admin"],
  fournisseurs: ["directeur", "admin"],
  ventes: ["directeur", "admin", "comptable", "support"],
  relation: ["directeur", "admin", "support"],
  equipe: ["directeur"],
};

export const SUBTAB_ACCESS = {
  // Général
  reglages: ["directeur", "admin"], email: ["directeur", "admin"], growth: ["directeur", "admin"], facture: ["directeur", "admin", "comptable"],
  encaissement: ["directeur"], pneus: ["directeur", "admin"], rib: ["directeur", "comptable"], site: ["directeur", "admin"], journal: ["directeur", "admin"], data: ["directeur"],
  // Ventes
  commandes: ["directeur", "admin", "comptable", "support"], retours: ["directeur", "admin", "support"], promos: ["directeur", "admin"],
  // Relation
  clients: ["directeur", "admin", "support"], messages: ["directeur", "admin", "support"], avis: ["directeur", "admin", "support"], newsletter: ["directeur", "admin"],
};

export const canSection = (user, id) => !!user && (SECTION_ACCESS[id] || ["directeur"]).includes(user.role);
export const canSub = (user, id) => !!user && (SUBTAB_ACCESS[id] || ["directeur", "admin"]).includes(user.role);
